module.exports = "/assets/data/a9fcb99adc3101d4cb00738231f52965-BA6.data.json";